import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SelectedCompanyState = {
  selectedCompanyId: string | null;
  setSelectedCompanyId: (id: string) => void;
};

export const useSelectedCompanyStore = create<SelectedCompanyState>()(
  persist(
    set => ({
      selectedCompanyId: null,
      setSelectedCompanyId: id => set({ selectedCompanyId: id }),
    }),
    { name: 'secret-menu-selected-company' },
  ),
);
